import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Col, Alert, Table, Spinner, Button, Form, FloatingLabel } from 'react-bootstrap';
import PesquisaService from '../../../services/pesquisa';
import { Link } from 'react-router-dom';
import { Chart as ChartJS, Tooltip, Legend, CategoryScale, BarElement, LinearScale } from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(BarElement, Tooltip, Legend, CategoryScale, LinearScale);

const ListarPesquisas = () => {
    const [vazio, setVazio] = useState(false);
    const [medias, setMedias] = useState([]);
    const [ano, setAno] = useState();
    const [orgao, setOrgao] = useState();
    const [orgaoS, setOrgaoS] = useState([
        {
            orgao: "Administração"
        },
        {
            orgao: "Ouvidoria"
        },
        {
            orgao: "Transparência"
        },
        {
            orgao: "Coleta de lixo"
        },
        {
            orgao: "Conservação e limpeza das ruas"
        },
        {
            orgao: "Estradas viscinais"
        },
        {
            orgao: "Conservação de praças, jardins e canteiros"
        },
        {
            orgao: "Cultura"
        },
        {
            orgao: "Iluminação pública"
        },
        {
            orgao: "Segurança pública"
        },
        {
            orgao: "Meio ambiente"
        },
        {
            orgao: "Esporte e lazer"
        },
        {
            orgao: "Saúde"
        },
        {
            orgao: "Educação"
        },
        {
            orgao: "Assistência Social"
        },
        {
            orgao: "Governo e Gestão"
        },
        {
            orgao: "Sala do Empreendedor"
        },
        {
            orgao: "DFTP"
        },
        {
            orgao: "Turismo"
        },
        {
            orgao: "Trabalho"
        },
        {
            orgao: "Envelhecimento saudável"
        }
    ]);
    const [chartData, setChartData] = useState([{
        labels: [],
        datasets: [
            {
                data: [],
                backgroundColor: [
                    'red',
                    'orangered',
                    'orange',
                    'forestgreen',
                    'green'
                ],
            },
        ],
        orgaos: [],
    }]);

    const contador = async (filtros) => {
        const notasCores = {
            '1': 'red',
            '2': 'orangered',
            '3': 'orange',
            '4': 'forestgreen',
            '5': 'green'
        };

        try {
            const response = await PesquisaService.orgao(filtros);
            const orgaos = response.data;
            if (orgaos.length === 0) {
                alert("Nenhum dado encontrado!");
                return;
            }

            const chartDatasets = [];

            orgaos.forEach(orgao => {
                const data = new Array(5).fill(0); 

                orgao.notas.forEach(notaObj => {
                    data[parseInt(notaObj.nota) - 1] = parseInt(notaObj.count);
                });

                const backgroundColor = ['1', '2', '3', '4', '5'].map(nota => notasCores[nota]);

                chartDatasets.push({
                    orgao: orgao.orgao,
                    data: data,
                    backgroundColor: backgroundColor,
                });
            });

            setChartData(chartDatasets);
        } catch (error) {
            console.log(error);
        }
    };

    const fetchMedias = async () => {
        await contador();
        try {
            const response = await PesquisaService.media();
            if (response.data.length >= 1) {
                setMedias(response.data)
                setVazio(false)
            }
        } catch (error) {
            console.log(error);
        }
    };


    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: true,
            },
            tooltip: {
                enabled: true,
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    stepSize: 2,
                    callback: function (value) { if (Number.isInteger(value)) { return value; } }
                }
            },
            x: {
                display: true,
                ticks: {
                    autoSkip: false,
                    maxRotation: 0,
                    minRotation: 0
                }
            }
        },
        layout: {
            padding: {
                bottom: 50 // Ajuste para espaço dos rótulos personalizados
            }
        }
    };
    const busca = async (query) => {
        if (query === "") {
            await contador();
        } else {
            var response = await contador(query);
            if (response.data.length >= 1) {
                setAno("")
                setOrgao("")
            } else {
                setAno("")
                setOrgao("")
            }
        }
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (ano) prepQuery = prepQuery + `&ano=${ano}`;
        if (orgao !== false && orgao !== "false" && orgao !== "") prepQuery = prepQuery + `&orgao=${orgao}`;
        return prepQuery;
    }


    useEffect(() => {
        fetchMedias();
    }, []);


    return (
        <Fragment>
            <Row xs={1}>
                <Col xs={{ span: 2, offset: 11 }}>
                    <Link to='/ouvidoria'>
                        <Button type='button' variant='danger'>Voltar</Button>
                    </Link>
                </Col>
            </Row>
            <h5>Resultados de Pesquisa de Satisfação</h5>
            {vazio ? <Fragment>
                <Alert variant='danger'>Nenhuma pesquisa recebida ainda :(</Alert>
            </Fragment> :
                <Fragment>
                    <Row>
                        {medias.length > 0 ?
                            <Fragment>
                                <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>Órgão</th>
                                            <th>Média</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {medias.map((media, index) => (
                                            <tr key={index}>
                                                <td>{media.orgao}</td>
                                                <td>{media.mediaNota.toFixed(1)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Fragment>
                            : <Spinner animation="border" role="status">
                                <span className="visually-hidden">Carregando...</span>
                            </Spinner>}
                    </Row>
                    <br />
                    <h5>Notas por Orgão</h5>
                    <br />
                    {/*<Row xs={3} lg={3}>
                        <Col xs={3} lg={3}>
                            <Form.Group className="mb-3" controlId="Ano">
                                <FloatingLabel
                                    label="Ano"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="number"
                                        name="ano"
                                        value={ano}
                                        onChange={e => setAno(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={3} lg={6}>
                            <Form.Group className="mb-3" controlId="orgao">
                                <FloatingLabel
                                    label="Serviço"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Serviço"
                                        name="orgao"
                                        onChange={e => setOrgao(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        {orgaoS.map((org) =>
                                            <option value={org.orgao}>{org.orgao}</option>
                                        )}
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={3} lg={2}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                                    </Row>*/}

                    <Row xs={1} lg={2}>
                        {chartData.map((data, index) => (
                            <Fragment>
                                <Col>
                                    <div key={index} style={{ width: '95%', height: '500px', display: 'block', margin: '1rem auto' }}>
                                        <h5>{data.orgao}</h5>
                                        <Bar data={{
                                            labels: ['1', '2', '3', '4', '5'],
                                            datasets: [{
                                                label: "Notas por serviço",
                                                data: data.data,
                                                backgroundColor: data.backgroundColor,
                                            }]
                                        }} options={options} />
                                    </div>
                                </Col>
                            </Fragment>
                        ))}
                        <br />
                        <br />
                    </Row>
                </Fragment>}
        </Fragment>

    )
}

export default ListarPesquisas;